<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>View Docs Template</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ docsTemplateDescription.name }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ docsTemplateDescription.description }}
            </div>

          </div>
          <ckeditor id="editor" v-model="docsTemplateDescription.template_text" :config="editorConfig"></ckeditor>

         

          <div class="vx-row mb-6 mt-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Variables:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ docsTemplateDescription.variables }}
            </div>

          </div>







        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import { quillEditor } from "vue-quill-editor";
export default {
  beforeMount() {
  },
  data() {
    return {
      editorConfig: {
          extraPlugins : 'justify,colorbutton',
            // The configuration of the editor.
        },
      docsTemplateDescription: [],
      docsTemplateId: null,
      selected_campaign: null,
      selected_campaign_id: null,
      campaign_required: null,
      companySearchComponentKey: 0,
      selected: [],
      abilities: null,
      campaign_grade_lists: [],
    };
  },
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
    // quillEditor
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
    this.docsTemplateId = this.$route.params.docsTemplateId;
    this.fetchDocsTemplate()

  },
  watch: {
  },
  methods: {
    fetchDocsTemplate() {
      this.$store
        .dispatch("campaignsManagement/fetchDocsTemplate", this.docsTemplateId)
        .then(res => {
          this.docsTemplateDescription = res.data;
          // this.docsTemplateDescription = this.docsTemplateDescription[0];
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.ql-class {
  height: 400px;

}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
